import { localeMapping } from '@/constants/localeMapping';
import { getLocalizationInfo } from '@/project.config';
import { Product } from '@shared/types/product';
import { pt } from 'date-fns/locale';
import { BaseHit, Hit } from 'instantsearch.js';

interface ProductHitVariant {
  id: string;
  sku: string;
  images: string[];
  prices: Record<string, { centAmount: number; fractionDigits: number }>;
  isOnStock: boolean;
}

interface ProductHit extends BaseHit {
  productId: string;
  categories?: any;
  categoryKeys?: any;
  name: any;
  variants: Array<ProductHitVariant>;
}

export const mapProduct = (hit: Hit<BaseHit>, locale: string): Product => {
  
  const productHit = hit as Hit<ProductHit>;
  const localeKey = localeMapping[locale];

  const slug = (productHit.name[localeKey] ?? '').toLowerCase().replace(/\s/g, '-');

  const { currency } = getLocalizationInfo(locale)

  return {
    productId: productHit?.productId,
    name: productHit?.name[localeKey] ?? productHit?.name['en-AU'],
    categories: productHit?.categoryKeys?.[localeKey]?.map((category: any) => ({
      categoryId: category,
      subCategories: [],
    })),
    variants: productHit?.variants?.map((variant) => ({
      ...variant,
      price: { ...variant.prices[currency], currencyCode: currency },
    })),
    _url: `/${slug}/p/${productHit?.sku}`,
  };
};
